var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("section-title", {
        attrs: { content: "Información de SIFDE", "has-line": "" }
      }),
      _vm.listOfSIFDE.length == 0
        ? _c("div", { staticClass: "bg-secondary-13 rounded my-3" }, [
            _c(
              "div",
              { staticClass: "col-12 py-4 text-center" },
              [
                !_vm.readOnly
                  ? _c(
                      "button",
                      {
                        staticClass: "btn bg-light-white col-12 col-md-4",
                        on: { click: () => _vm.getVendorInfo(true) }
                      },
                      [
                        _c("em", {
                          staticClass: "fas fa-file-plus pr-4 text-green"
                        }),
                        _c(
                          "span",
                          { staticClass: "text-button-add-document" },
                          [
                            _vm._v(
                              " Presione aquí para añadir informacion de SIFDE "
                            )
                          ]
                        )
                      ]
                    )
                  : _c("custom-result-not-found", { staticClass: "py-5" })
              ],
              1
            )
          ])
        : _c("div", [
            _c(
              "div",
              { staticClass: "mb-4 d-flex flex-row-reverse" },
              [
                !_vm.readOnly
                  ? _c("action-button", {
                      attrs: {
                        id: "btnAddEntry",
                        i: "far fa-undo",
                        text: "Actualizar PO",
                        variant: "outline-success pl-4 pr-4"
                      },
                      on: { click: () => _vm.getVendorInfo(true) }
                    })
                  : _vm._e()
              ],
              1
            ),
            _c("div", { staticClass: "row mb-4" }, [
              _c(
                "div",
                { staticClass: "col-12" },
                _vm._l(_vm.listOfSIFDE, function(item) {
                  return _c("SIFDERow", {
                    key: item.purchaseOrderId,
                    attrs: { value: item },
                    on: { "on-update-po": _vm.onUpdatePoHandler }
                  })
                }),
                1
              )
            ])
          ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }